const _excluded = ["onChange", "onFocus", "onBlur", "value", "error", "size", "readOnly", "disabled", "onDropAccepted", "onDropRejected", "onDragEnter", "onDragLeave", "accept", "camera", "components"],
  _excluded2 = ["Container"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
import { DropZoneFile } from "./drop-zone";
import { getCameraOptions } from "./drop-camera";
import { componentsMultiFile as defaultComponents } from "./components";
import { useDropMultiFileStatus } from "./drop-status";
export const InputDropMultiFile = props => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onFocus,
      onBlur,
      value,
      error,
      size,
      readOnly,
      disabled,
      onDropAccepted,
      onDropRejected,
      onDragEnter,
      onDragLeave,
      accept,
      camera = true,
      components = defaultComponents
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const {
      Container = defaultComponents.Container
    } = components,
    restComponents = _objectWithoutProperties(components, _excluded2);
  const common = {
    onChange,
    onFocus,
    onBlur,
    value,
    error,
    size,
    readOnly,
    disabled
  };
  const cameraOptions = React.useMemo(() => getCameraOptions(camera, accept), [camera, accept]);
  const status = useDropMultiFileStatus(value, onChange);
  const {
    addFiles,
    addFilesRejected
  } = status;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropZoneFile, _extends({
    multiple: true,
    error: error,
    accept: accept,
    disabled: disabled || readOnly,
    onDragEnter: e => {
      onDragEnter && onDragEnter(e);
      onFocus && onFocus();
    },
    onDragLeave: e => {
      onDragLeave && onDragLeave(e);
      onBlur && onBlur();
    },
    onDropAccepted: (files, e) => {
      onDropAccepted && onDropAccepted(files, e);
      addFiles(files);
    },
    onDropRejected: (rejections, e) => {
      onDropRejected && onDropRejected(rejections, e);
      addFilesRejected(rejections);
    }
  }, rest), drop => /*#__PURE__*/React.createElement(Container, {
    drop: drop,
    common: common,
    camera: cameraOptions,
    status: status,
    components: restComponents
  })));
};